import NeighborhoodPage from "@/components/NeighborhoodPage";

const Gloria = () => (
  <NeighborhoodPage
    name="Glória"
    slug="gloria"
    description="Vizinho ao Centro e à Marina da Glória, um bairro em transformação com vista para a Baía de Guanabara e ótimo custo-benefício para investimento no Rio."
  />
);

export default Gloria;
